<template>
    <div>
        <section class="my-4">
            <recipe-item-association-create :recipeId="$route.params.id" @create="getAssociations"/>
        </section>
        <div v-loading="loading">
            <el-table :data="associations" style="width: 100%" :default-sort = "{ prop: 'title', order: 'ascending' }" empty-text="No associated recipes were found.">
                <el-table-column label="Recipe">
                    <template slot-scope="props">
                        <router-link :to="{ name: 'recipes-id', params: { id: props.row.id } }">{{ props.row.title }}</router-link>
                    </template>
                </el-table-column>
                <el-table-column label="Operations">
                    <template slot-scope="props">
                        <recipe-item-association-delete :recipeId="recipeId" :associationId="props.row.id" @delete="getAssociations"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import RecipeItemAssociationCreate from '@/components/Recipe/Item/RecipeItemAssociationCreate'
import RecipeItemAssociationDelete from '@/components/Recipe/Item/RecipeItemAssociationDelete'

export default {
    data() {
        return {
            loading: false,
            associations: this.recipeAssociations,
        }
    },

    props: {
        recipeId: {
            required: true,
            type: String,
        },
        recipeAssociations: {
            required: true,
            type: Array,
        },
    },

    components: {
        RecipeItemAssociationCreate,
        RecipeItemAssociationDelete,
    },

    methods: {
        async getAssociations() {
            this.loading = true
            this.associations = []

            try {
                var { data } = await this.$http.get(`/recipes/${ this.recipeId }`)
            } catch(err) {
                this.$message.error(err.response.data.message)

                return
            } finally {
                this.loading = false
            }

            this.associations = data.recipes
        },
    },
}
</script>
